import React from "react";
import { Breadcrumbs, Link, Typography, Box } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import FolderIcon from "@mui/icons-material/Folder";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

export interface BreadcrumbItem {
  label: string;
  path: string[];
  isClickable?: boolean;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  onNavigate: (path: string[]) => void;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, onNavigate }) => {
  const handleBreadcrumbClick = (path: string[]) => {
    onNavigate(path);
  };

  return (
    <Box sx={{ py: 2, px: 1 }}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" sx={{ color: "#fff" }} />}
        aria-label="breadcrumb"
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: "#fff",
          },
        }}
      >
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const isClickable = item.isClickable !== false && !isLast;
          const key = `${item.label}-${item.path.join('-')}-${index}`;

          if (isClickable) {
            return (
              <Link
                key={key}
                component="button"
                variant="body2"
                onClick={() => handleBreadcrumbClick(item.path)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: "rgba(255, 255, 255, 0.7)",
                  textDecoration: "none",
                  cursor: "pointer",
                  "&:hover": {
                    color: "#fff",
                    textDecoration: "underline",
                  },
                  border: "none",
                  background: "none",
                  fontSize: "0.875rem",
                  padding: 0,
                }}
              >
                {index === 0 ? (
                  <HomeIcon sx={{ mr: 0.5, fontSize: "1rem" }} />
                ) : (
                  <FolderIcon sx={{ mr: 0.5, fontSize: "1rem" }} />
                )}
                {item.label}
              </Link>
            );
          }

          return (
            <Typography
              key={key}
              variant="body2"
              sx={{
                display: "flex",
                alignItems: "center",
                color: "#fff",
                fontWeight: isLast ? 600 : 400,
              }}
            >
              {index === 0 ? (
                <HomeIcon sx={{ mr: 0.5, fontSize: "1rem" }} />
              ) : (
                <FolderIcon sx={{ mr: 0.5, fontSize: "1rem" }} />
              )}
              {item.label}
            </Typography>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default Breadcrumb;